{
  "deep_search.advanced_no_suggestions": "No suggestions",
  "deep_search.advanced_no_suggestions_hint": "Type a field name or pick an example",
  "deep_search.advanced_placeholder": "Search documents… e.g. Name:invoice Tag:invoice FileSize:>1000",
  "deep_search.attr.doc.Currency": "Currency",
  "deep_search.attr.doc.CustomerCity": "Customer city",
  "deep_search.attr.doc.CustomerCountry": "Customer country",
  "deep_search.attr.doc.CustomerName": "Customer name",
  "deep_search.attr.doc.CustomerZip": "Customer zip",
  "deep_search.attr.doc.DocumentLanguage": "Language",
  "deep_search.attr.doc.DocumentTitle": "Document title",
  "deep_search.attr.doc.DocumentType": "Document type",
  "deep_search.attr.doc.DueDate": "Due date",
  "deep_search.attr.doc.InvoiceDate": "Invoice date",
  "deep_search.attr.doc.InvoiceNumber": "Invoice number",
  "deep_search.attr.doc.InvoicePeriodFrom": "Period from",
  "deep_search.attr.doc.InvoicePeriodTo": "Period to",
  "deep_search.attr.doc.PurchaseOrderNumber": "Purchase order number",
  "deep_search.attr.doc.TotalInclVat": "Total VAT included",
  "deep_search.attr.doc.VendorCity": "Vendor city",
  "deep_search.attr.doc.VendorCountry": "Vendor country",
  "deep_search.attr.doc.VendorName": "Vendor name",
  "deep_search.attr.doc.VendorZip": "Vendor zip",
  "deep_search.attr.Assignee": "Assigned",
  "deep_search.boolean_and_subtitle": "Require both sides",
  "deep_search.boolean_close_group": "Close group",
  "deep_search.boolean_negate": "Negate next qualifier or term",
  "deep_search.boolean_not_subtitle": "Exclude following term",
  "deep_search.boolean_open_group": "Open group",
  "deep_search.boolean_or_subtitle": "Match either side",
  "deep_search.common_apply": "Apply",
  "deep_search.common_back": "Back",
  "deep_search.common_save": "Save",
  "deep_search.date_picker_bare_date_hint": "Bare dates match the whole day in the active timezone (default Europe/Zurich).",
  "deep_search.date_picker_include_time": "Include time",
  "deep_search.date_picker_utc": "UTC",
  "deep_search.date_picker_utc_date_only_hint": "Calendar date (UTC). Matches the whole UTC day; unaffected by tz:.",
  "deep_search.detail_clear": "Clear",
  "deep_search.error.DANGLING_OPERATOR": "Incomplete operator in query ({operator})",
  "deep_search.error.DUPLICATE_SORT_KEY": "Duplicate sort field: {key}",
  "deep_search.error.EMPTY_VALUE": "sort: requires at least one field",
  "deep_search.error.INVALID_ATTRIBUTE_KEY": "Cannot sort by this attribute: {key}",
  "deep_search.error.INVALID_TIMEZONE": "Unknown timezone: {zone}",
  "deep_search.error.INVALID_VALUE_FORMAT": "Use a full calendar date (YYYY-MM-DD)",
  "deep_search.error.INVALID_WILDCARD": "Leading wildcards are not supported",
  "deep_search.error.MISPLACED_DIRECTIVE": "sort: and tz: must come at the end of the query",
  "deep_search.error.QUERY_TOO_COMPLEX": "This query is too complex",
  "deep_search.error.UNBALANCED_BRACES": "Unbalanced parentheses in query",
  "deep_search.error.VALIDATION_ERROR": "Invalid search query",
  "deep_search.field.CreatedTime": "Created",
  "deep_search.field.CreatedUser": "Created by",
  "deep_search.field.FileSize": "File size",
  "deep_search.field.Kind": "Kind",
  "deep_search.field.ModifiedTime": "Modified",
  "deep_search.field.ModifiedUser": "Modified by",
  "deep_search.field.Name": "Name",
  "deep_search.field.OwnerUser": "Owner",
  "deep_search.field.Tag": "Tag",
  "deep_search.field.Type": "Type",
  "deep_search.filters_all": "All",
  "deep_search.filters_clear_selected": "Clear selected items",
  "deep_search.filters_select_all": "Select all filters",
  "deep_search.filters_contains_placeholder": "Contains text",
  "deep_search.filters_enter_value": "Enter {label}…",
  "deep_search.filters_find_criteria": "Find criteria…",
  "deep_search.filters_find_sort": "Find sort…",
  "deep_search.filters_find_value": "Find {label}…",
  "deep_search.filters_loading_options": "Loading options…",
  "deep_search.filters_mode_date": "Date / range",
  "deep_search.filters_mode_number": "Number / range",
  "deep_search.filters_mode_options": "Choose value",
  "deep_search.filters_mode_text": "Text",
  "deep_search.filters_more": "More",
  "deep_search.filters_others": "(+ {count} others)",
  "deep_search.filters_no_matching_criteria": "No matching criteria",
  "deep_search.filters_number_range": "Number range…",
  "deep_search.filters_pick_date": "Pick a date…",
  "deep_search.filters_pick_date_range": "Pick a date range…",
  "deep_search.filters_sort_label": "Sort:",
  "deep_search.filters_sort_relevance": "Relevance (default)",
  "deep_search.filters_use_value": "Use “{value}”",
  "deep_search.menu_all": "All",
  "deep_search.menu_find": "Find…",
  "deep_search.menu_no_matching": "No matching options",
  "deep_search.number_range_from": "From",
  "deep_search.number_range_preset_0_up": "0 and up",
  "deep_search.number_range_preset_100_500": "100 – 500",
  "deep_search.number_range_preset_1k_5k": "1,000 – 5,000",
  "deep_search.number_range_preset_up_to_1k": "Up to 1,000",
  "deep_search.number_range_presets": "Presets",
  "deep_search.number_range_to": "To",
  "deep_search.options_load_failed": "Could not load filter options",
  "deep_search.relative_14d": "14 days ago",
  "deep_search.relative_1h": "1 hour ago",
  "deep_search.relative_24h": "24 hours ago",
  "deep_search.relative_30d": "30 days ago",
  "deep_search.relative_7d": "7 days ago",
  "deep_search.save_dialog_cancel": "Cancel",
  "deep_search.save_dialog_confirm": "Save",
  "deep_search.save_dialog_confirm_create": "Save search",
  "deep_search.save_dialog_edit_subtitle": "Update the name or pinned view. The query is shown for reference.",
  "deep_search.save_dialog_edit_title": "Edit search",
  "deep_search.save_dialog_name": "Search name",
  "deep_search.save_dialog_name_required": "Enter a name",
  "deep_search.save_dialog_query": "Query",
  "deep_search.save_dialog_subtitle": "Save the current search for quick access later.",
  "deep_search.save_dialog_table_options": "Custom columns",
  "deep_search.save_dialog_table_options_hint": "This column selection is saved with the search. Remove it to use the view's own columns instead.",
  "deep_search.save_dialog_title": "Save search",
  "deep_search.save_dialog_variant": "Search mode",
  "deep_search.save_dialog_view": "View",
  "deep_search.save_dialog_view_hint": "Remove to apply this search on whatever view you are currently in.",
  "deep_search.sort_created_newest": "Created (newest)",
  "deep_search.sort_file_size_largest": "File size (largest)",
  "deep_search.sort_modified_newest": "Modified (newest)",
  "deep_search.sort_modified_oldest": "Modified (oldest)",
  "deep_search.sort_name_az": "Name (A–Z)",
  "deep_search.sort_relevance": "Relevance",
  "deep_search.suggestion_absolute_date": "Absolute date",
  "deep_search.suggestion_date_range": "Date range",
  "deep_search.suggestion_number_range": "Number range",
  "deep_search.variant_advanced": "Advanced",
  "deep_search.variant_incompatible_boolean": "This query uses boolean operators — switch to Advanced",
  "deep_search.variant_incompatible_complex": "This query is too complex for Simple — switch to Advanced",
  "deep_search.variant_incompatible_grouping": "This query uses grouping / nesting — switch to Advanced",
  "deep_search.variant_simple": "Simple",
  "deep_search.location_everywhere": "Everywhere in {location}",
  "deep_search.location_current": "Current: {location}",
  "deep_search.location_more": "More locations…",
  "deep_search.location_select_title": "Select location",
  "deep_search.location_clear": "Search entire box",
  "deep_search.location_reset_default": "Reset to default location",
  "deep_search.table_header_location": "Location",
  "deep_search.search_in_location": "Search in \"{location}\"…",
  "deep_search.quick_show_all": "Show all results",
  "deep_search.quick_no_results": "No results",
  "deep_search.quick_modified_by": "Modified by {user} · {when}"
}
